import script from "./clInfoList.vue?vue&type=script&setup=true&lang=js"
export * from "./clInfoList.vue?vue&type=script&setup=true&lang=js"

import "./clInfoList.vue?vue&type=style&index=0&id=59275e42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59275e42"]])

export default __exports__